import { groupBy } from 'underscore';

import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

export function groupWorkspaceItemsByType(data: Array<WorkspaceItem>) {
  const { folder = [], quiz = [] } = groupBy(
    data,
    (workspaceItem) => workspaceItem.type
  );
  return { folder, quiz };
}
